import { Injectable, inject } from '@angular/core';
import { SERVICEMESH_CONFIG } from '@helpers/services/config/config.constants';
import { merge } from 'lodash-es';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ServicemeshConfigService {
  // The config is an open-ended bag provided via InjectionToken<unknown>; `any`
  // is intentional so consumers can extend it freely without casts.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private readonly _config: BehaviorSubject<any>;

  /**
   * Constructor
   */
  constructor() {
    const config = inject(SERVICEMESH_CONFIG);

    // Private
    this._config = new BehaviorSubject(config);
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Accessors
  // -----------------------------------------------------------------------------------------------------

  /**
   * Setter & getter for config
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  set config(value: any) {
    // Merge the new config over to the current config
    const config = merge({}, this._config.getValue(), value);

    // Execute the observable
    this._config.next(config);
  }

  // eslint-disable-next-line @typescript-eslint/member-ordering, @typescript-eslint/no-explicit-any
  get config$(): Observable<any> {
    return this._config.asObservable();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Resets the config to the default
   */
  reset(): void {
    // Set the config
    this._config.next(this.config);
  }
}
